import "./_segmented-toggle.scss";

const normalizeOption = (option) =>
  typeof option === "string" ? { label: option, value: option } : option;

/**
 * Pure-UI 2+-option segmented control. `value`/`onChange` follow the same
 * raw-value convention as every other input in this codebase (no DOM
 * event). Used for both the Plans list's List/Gallery view switch and the
 * Plan pricing editor's Fee type/Terms/Collection toggles - replaces the
 * old `FormInputSegmentedToggle` from @simplifyhq/simplify-ui-reusables.
 */
const SegmentedToggle = ({ id, label, options = [], value, onChange, disabled = false, className = "" }) => {
  const normalized = options.map(normalizeOption);

  return (
    <div className={`segmented-toggle ${disabled ? "segmented-toggle--disabled" : ""} ${className}`}>
      {label && <span className="segmented-toggle__label">{label}</span>}
      <div className="segmented-toggle__track" role="radiogroup" aria-label={label}>
        {normalized.map((option) => (
          <button
            key={option.value}
            id={id && `${id}-${option.value}`}
            type="button"
            role="radio"
            aria-checked={value === option.value}
            className={`segmented-toggle__option ${value === option.value ? "segmented-toggle__option--active" : ""}`}
            disabled={disabled}
            onClick={() => onChange?.(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SegmentedToggle;
